import React, { useEffect, useState, FC } from 'react'

interface OnlineWidgetProps {
    data: number;
    data2: number;
}

const OnlineWidget: FC<OnlineWidgetProps> = ({ data, data2 }) => {
    const [online, setOnline] = useState(data);

    useEffect(() => {
        const timer = setInterval(() => {
            const chance = Math.random();
            let change = 0;

            if (chance < 0.2) {
                change = 0;
            } else if (chance < 0.7) {
                change = Math.floor(Math.random() * 30) * (Math.random() > 0.5 ? 1 : -1);
            } else {
                change = Math.floor(Math.random() * 100) * (Math.random() > 0.5 ? 1 : -1);
            }

            setOnline((prev) => Math.max(data2, prev + change));
        }, 800);

        return () => clearInterval(timer);
    }, [data2]);

    return (
        <>
            <div className="online-glow-wrapper">
                <div className="online-glow-box">
                    <span className="pulse-circle" />
                    <span className="online-text">
                        ออนไลน์ <strong>{online.toLocaleString('th-TH')}</strong> คน
                    </span>
                </div>
            </div>
        </>
    )
}

export default OnlineWidget
